import { ChevronDownIcon, ChevronUpIcon, InfoIcon } from '@rsos/assets/icons';
import Loader from '@rsos/base-components/Loader';
import { type Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import ConversationRow from './ConversationRow';
import styles from './ConversationTable.module.scss';

interface ConversationTableProps {
  displayList: Conversation[];
  isSortReversed: boolean;
  onSort: () => void;
  checkedList: Set<string>;
  isSelectedAllChecked: boolean;
  onToggleSelectAll: () => void;
  onCheck: (id: string) => void;
  onDownload: (ids: string[]) => void;
  isDownloading: boolean;
  isLoading?: boolean;
  isError?: boolean;
}

const ConversationTable = ({
  displayList,
  isSortReversed,
  onSort,
  checkedList,
  isSelectedAllChecked,
  onToggleSelectAll,
  onCheck,
  onDownload,
  isDownloading,
  isLoading = false,
  isError = false,
}: ConversationTableProps) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>
              <input
                type="checkbox"
                checked={isSelectedAllChecked}
                onChange={onToggleSelectAll}
              />
            </th>
            <th className={styles.th}>PHONE NUMBER</th>
            <th className={`${styles.th} ${styles.sortable}`} onClick={onSort}>
              START TIME
              <span className={styles.sortIcon}>
                {isSortReversed ? (
                  <ChevronUpIcon width={12} height={12} />
                ) : (
                  <ChevronDownIcon width={12} height={12} />
                )}
              </span>
            </th>
            <th className={styles.th}>DURATION</th>
            <th className={styles.th}>TYPE</th>
            <th className={styles.th}>STATUS</th>
            <th className={styles.th}>
              <span className={styles.thWithIcon}>
                REMAINING DAYS
                <span
                  className={styles.infoTooltip}
                  data-tooltip="This is the number of days remaining that RapidSOS will store your conversations before permanently deleting them."
                >
                  <InfoIcon width={12} height={12} />
                </span>
              </span>
            </th>
            <th className={styles.th} />
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={8}>
                <Loader text="Loading conversations..." fluid />
              </td>
            </tr>
          ) : isError ? (
            <tr>
              <td colSpan={8} className={`${styles.emptyRow} ${styles.danger}`}>
                Failed to load conversations.
              </td>
            </tr>
          ) : (
            <>
              {displayList.map(d => (
                <ConversationRow
                  key={d.conversation_id}
                  conversation={d}
                  isChecked={checkedList.has(d.conversation_id)}
                  onCheck={onCheck}
                  onDownload={onDownload}
                  isDownloading={isDownloading}
                />
              ))}
              {displayList.length === 0 && (
                <tr>
                  <td colSpan={8} className={styles.emptyRow}>
                    No conversations found.
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ConversationTable;
